import { create } from 'zustand'
import { breadcrumbsStore, type BreadcrumbsStore, type CrumbInsert, type CrumbOverrides } from './breadcrumbs'
import { headerStore, type HeaderStore } from './header'
import { settingsStore, type SettingsStore } from './settings'
import { sidebarStore, type SidebarStore } from './sidebar'

export interface GlobalState {
  header: HeaderStore
  sidebar: SidebarStore
  settings: SettingsStore
  breadcrumbs: BreadcrumbsStore

  setSidebarOpen: (open: boolean) => void
  setSearchWorksheets: (searchWorksheets: string) => void
  setBreadcrumbOverrides: (overrides: CrumbOverrides) => void
  setBreadcrumbInserts: (inserts: CrumbInsert[]) => void
}

export const useStore = create<GlobalState>((set) => ({
  header: headerStore,
  sidebar: sidebarStore,
  settings: settingsStore,
  breadcrumbs: breadcrumbsStore,

  setSidebarOpen: (open) => set((state) => ({
    sidebar: { ...state.sidebar, open }
  })),
  setSearchWorksheets: (searchWorksheets) => set((state) => ({
    header: { ...state.header, searchWorksheets }
  })),
  setBreadcrumbOverrides: (overrides) => set((state) => ({
    breadcrumbs: { ...state.breadcrumbs, overrides }
  })),
  setBreadcrumbInserts: (inserts) => set((state) => ({
    breadcrumbs: { ...state.breadcrumbs, inserts }
  })),
}))
